import { render, staticRenderFns } from "./OverviewsUserDetails.vue?vue&type=template&id=857ec580&"
import script from "./OverviewsUserDetails.vue?vue&type=script&lang=js&"
export * from "./OverviewsUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports